<section
	[ngClass]="{
		'rounded-none border border-mainColorLight bg-mainColorHoverBg px-2 py-2': showSearchOnly,
		'rounded-none bg-transparent p-0': !showSearchOnly,
	}"
	class="top-search w-full h-auto md:h-full md:bg-white relative z-50 shadow-none md:shadow-[0_10px_30px_rgba(0,0,0,0.15)] md:rounded-[30px] md:p-6"
>
	<div
		class="relative mx-auto my-0 flex h-auto w-full flex-col gap-2 justify-start md:h-full md:justify-center md:gap-0 md:pt-0"
	>
		@if (!showSearchOnly) {
			<article class="w-full lg:mx-auto lg:grid lg:grid-cols-12 lg:gap-6 lg:items-stretch">
				<div
					[class]="isOfferList ? 'lg:col-span-12' : 'lg:col-span-10'"
					class="flex w-full flex-col gap-2 lg:min-w-0"
				>
					<app-top-search-filter-items class="w-full" [filters]="TopSearchMainConfigWithoutSearch">
					</app-top-search-filter-items>
				</div>
				<div class="hidden md:block mb-0 lg:mb-0 lg:col-span-2 lg:self-stretch">
					@if (!isOfferList) {
						<button
							class="bg-accentColor px-4 tracking-wide font-semibold text-sm text-white rounded-[12px] h-full w-full hover:bg-accentHoverColor transition-colors uppercase flex items-center justify-center gap-1.5"
							(click)="goToOfferList()"
							data-testid="search-offers-btn"
						>
							<i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i>
							Szukaj
						</button>
					}
				</div>
			</article>
		}

		<div class="flex w-full flex-col gap-2 md:mt-4 md:gap-0">
			@if (!showSearchOnly) {
				<div class="relative mb-3 hidden items-center justify-center md:flex">
					<div
						class="absolute inset-x-0 top-1/2 -translate-y-1/2 border-t"
						style="border-top-width: 1px; border-top-color: var(--main-color-light)"
					></div>
					<span
						class="relative bg-white px-4 text-xs font-semibold tracking-[0.18em] uppercase"
						style="color: var(--main-color-hover-85); opacity: 0.6"
					>
						Lub wyszukaj po nazwie
					</span>
				</div>
			}
			<div class="relative">
				<i
					(click)="searchByName()"
					class="absolute left-4 top-1/2 -translate-y-1/2 fa-solid fa-magnifying-glass text-mainColor cursor-pointer hover:text-mainColor"
				></i>
				<input
					(keydown.enter)="searchByName()"
					(blur)="onSearchInputBlur()"
					type="text"
					[ngModel]="searchValue()"
					(ngModelChange)="searchValue.set($event)"
					class="h-12 w-full rounded-xl border border-mainColorLight ps-12 pe-4 text-mainColor font-semibold placeholder:text-gray-400 focus:outline-none bg-white md:h-14 md:bg-mainColorHoverBg md:border-mainColorHoverBg"
					placeholder="Szukaj kraju, miasta, hotelu..."
				/>
			</div>
			@if (!isOfferList) {
				<button
					class="mt-3 flex w-full items-center justify-center gap-1.5 rounded-[12px] bg-accentColor px-4 py-2.5 text-sm font-semibold uppercase tracking-wide text-white transition-colors hover:bg-accentHoverColor md:hidden"
					(click)="goToOfferList()"
					data-testid="search-offers-btn-mobile"
				>
					<i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i>
					Szukaj
				</button>
			}
		</div>
	</div>
</section>
